module.exports = __webpack_public_path__ + "static/img/qatar-airways.b33681b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/qatar-airways.svg
// module id = qdjO
// module chunks = 1